import { render, staticRenderFns } from "./improvement-issue.vue?vue&type=template&id=44e2b891&scoped=true"
import script from "./improvement-issue.vue?vue&type=script&lang=js"
export * from "./improvement-issue.vue?vue&type=script&lang=js"
import style0 from "./improvement-issue.vue?vue&type=style&index=0&id=44e2b891&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e2b891",
  null
  
)

export default component.exports